<div class="hero-section">
  <div class="row align-items-center">
    <!-- Left: Content -->
    <div class="col-lg-6 col-md-12 hero-content">
      <div class="hero-line"></div>
      <h1>Empowering Businesses Through Strategic Software Consulting</h1>
      <p>
        From shaping long-term technology strategies to implementing
        cutting-edge solutions across Cloud, DevOps, AI, and Cybersecurity,
        MALtech provides expert consulting that helps businesses innovate,
        streamline operations, and scale securely.
      </p>
      <a routerLink="/contact" href="/contact" class="btn hero-btn">Join Us</a>
    </div>

    <!-- Right: Image -->
    <div class="col-lg-6 col-md-12 hero-image text-center">
      <img
        src="assets/images/consulting/hero-image.webp"
        alt="Consulting Services Overview"
        class="img-fluid"
        width="390"
        loading="lazy"
      />
    </div>
  </div>
</div>

<section
  class="why-company"
  aria-label="Why Choose MALtech?"
  id="why-choose-us"
  id="get-start"
>
  <div class="container">
    <h2 class="section-title">Why Choose MALtech?</h2>

    <div class="card-grid">
      <article class="card-item border-2" *ngFor="let card of cards2">
        <img
          [src]="card.icon"
          alt="{{ card.title }}"
          class="card-icon"
          loading="lazy"
        />
        <h3 class="card-title h3">{{ card.title }}</h3>
        <p class="card-desc">{{ card.description }}</p>
      </article>
    </div>
  </div>
</section>

<section class="section2 container" aria-label="Our Approach">
  <h2 class="section-title2">Our Approach</h2>

  <div class="approach-list2">
    <article class="approach-card2" *ngFor="let step of steps; let i = index">
      <div class="icon-wrapper2">
        <div class="icon2">
          <i [class]="step.icon"></i>
        </div>

        <ng-container *ngIf="i < steps.length - 1">
          <div class="line long-line" aria-hidden="true"></div>
          <div class="line short-line" aria-hidden="true"></div>
        </ng-container>
      </div>

      <div class="content2">
        <h3 class="card-title2 h3">{{ step.title }}</h3>
        <p class="card-description2">{{ step.description }}</p>
      </div>
    </article>
  </div>
</section>

<section
  class="section3"
  aria-label="Cloud, DevOps & Automation Consulting Services"
>
  <h2 class="section-title3">{{ section3Title }}</h2>

  <div class="card-grid3">
    <article class="card3" *ngFor="let card of cards3">
      <h3 class="card-title3 mt-4">{{ card.title }}</h3>
      <p class="card-description3">{{ card.description }}</p>
    </article>
  </div>
</section>

<section class="why-company4" aria-label="Why Choose Company?">
  <h2 class="section-title4">{{ section4Title }}</h2>
  <div class="container4">
    <div class="card-grid4">
      <article class="card4" *ngFor="let card of cards4">
        <i class="{{ card.icon }}" aria-hidden="true"></i>
        <h3 class="title4 h3">{{ card.title }}</h3>
        <p>{{ card.description }}</p>
      </article>
    </div>
  </div>
</section>

<section class="section5" aria-label="Call to Action">
  <div class="cta-container5">
    <h2 class="cta-title5">{{ title }}</h2>
    <p class="cta-description5">{{ description }}</p>
    <a routerLink="/contact" href="/contact" class="cta-btn5" routerLinkActive="active" aria-label="Let's Get Started">
      {{ buttonText }}
    </a>
  </div>
</section>
